export const comments_3750241 = {"data":{"data":[],"links":{}}}